import { toJS } from 'mobx';
import { ServiceNumber, ServiceNumberList } from '../stores/BillingStore';

export const applyBusinessLogic = (numberList: ServiceNumberList, translate: (key: string) => string): ServiceNumber[] => {
  const result: ServiceNumber[] = [];
  Array.from(numberList.serviceNumbers).forEach((observableServiceNumber) => {
    const serviceNumber = toJS(observableServiceNumber);
    addExtraInfo(serviceNumber, translate);
    addPriceDescription(serviceNumber, translate);
    removePriceIfNeeded(serviceNumber);
    result.push(serviceNumber);
  });
  return sortNumbers(result);
};

const addExtraInfo = (serviceNumber: ServiceNumber, translate: (key: string) => string) => {
  serviceNumber.extraInfos = [];

  if (serviceNumber.clearingType === 7) {
    serviceNumber.extraInfos.push(translate('serviceNumber.openInTelia'));
  }
  if (!serviceNumber.mobileOpened) {
    serviceNumber.extraInfos.push(translate('serviceNumber.closedInMobile'));
  }
  if (!serviceNumber.fixOpened) {
    serviceNumber.extraInfos.push(translate('serviceNumber.closedInFix'));
  }
  if (serviceNumber.roamingOpened) {
    serviceNumber.extraInfos.push(translate('serviceNumber.openInRoaming'));
  }
};

const addPriceDescription = (serviceNumber: ServiceNumber, translate: (key: string) => string) => {
  serviceNumber.priceDescription = [];
  addPriceDescriptionBasedOnClearingType(serviceNumber, translate);
  addPriceDescriptionBasedOnPriceType(serviceNumber, translate);
};

const addPriceDescriptionBasedOnClearingType = (serviceNumber: ServiceNumber, translate: (key: string) => string) => {
  if (!isPriceBasedClearingType(serviceNumber)) {
    switch (serviceNumber.clearingType) {
      case 1:
        serviceNumber.priceDescription.push(translate('serviceNumber.regularPrice'));
        break;
      case 2:
        serviceNumber.priceDescription.push(translate('serviceNumber.freePrice'));
        break;
      case 7:
        serviceNumber.priceDescription.push(translate('serviceNumber.verifyServicePrice'));
        break;
      default:
    }
  }
};

const addPriceDescriptionBasedOnPriceType = (serviceNumber: ServiceNumber, translate: (key: string) => string) => {
  if (isPriceBasedClearingType(serviceNumber) && isPriceDisplayingPriceType(serviceNumber)) {
    switch (serviceNumber.priceType) {
      case 'F':
        serviceNumber.priceDescription.push(translate('serviceNumber.eurosPerCall'));
        break;
      case 'M':
        serviceNumber.priceDescription.push(translate('serviceNumber.eurosPerMin'));
        break;
      default:
    }
  }
};

const removePriceIfNeeded = (serviceNumber: ServiceNumber) => {
  if (serviceNumber.clearingType !== 5 && (!isPriceBasedClearingType(serviceNumber) || !isPriceDisplayingPriceType(serviceNumber))) {
    serviceNumber.price = null;
  }
};

const isPriceBasedClearingType = (serviceNumber: ServiceNumber) => {
  return serviceNumber.clearingType === 3 || serviceNumber.clearingType === 4;
};

const isPriceDisplayingPriceType = (serviceNumber: ServiceNumber) => {
  return serviceNumber.priceType === 'M' || serviceNumber.priceType === 'F';
};

const sortNumbers = (numberList: ServiceNumber[]): ServiceNumber[] => {
  return numberList.sort((a, b) => {
    if (a.number.length > b.number.length) {
      return 1;
    } else if (a.number.length < b.number.length) {
      return -1;
    }
    if (a.number < b.number) {
      return -1;
    } else if (a.number > b.number) {
      return 1;
    }
    return 0;
  });
};
